<template>
  <b-button v-if="validateData()" variant="danger" @click="exportTo()">{{title ? title : 'Exportar'}}</b-button>
</template>

<script>
import { toExcelThree } from "@/utils";
export default {
name:'export-button',
  props: {
    title: String,
    data: Array,
    fileName: String
  },
  methods: {
      exportTo(){
          toExcelThree(this.data, this.fileName);
      },
      validateData(){
        if (this.data){
          return this.data.length > 0 ? true : false;
        }else{
          return false
        }
      }
  },
}
</script>